"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInstanceCleanup = void 0;
const react_1 = require("react");
const react_use_1 = require("react-use");
const selectors_1 = require("./module-registry/selectors");
const events_1 = require("./module-registry/events");
const useInstanceCleanup = ({ url, scope }) => {
    const [moduleData, setModuleData] = (0, react_1.useState)({ url, scope });
    const prevModuleData = (0, react_use_1.usePrevious)(moduleData);
    const moduleState = (0, selectors_1.useModuleByNameSelector)(scope);
    const cleanup = (0, react_1.useCallback)((data) => {
        (0, events_1.removeModuleInstance)({
            moduleName: data.scope
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (moduleData.scope !== scope) {
            setModuleData({ url, scope });
        }
    }, [moduleData, url, scope]);
    (0, react_1.useEffect)(() => {
        // Thos case supports changing scope of the remote module dynamically
        if (prevModuleData && prevModuleData.scope !== moduleData.scope) {
            cleanup(prevModuleData);
        }
    }, [prevModuleData, moduleData, cleanup]);
    (0, react_use_1.useUnmount)(() => {
        if (moduleData && moduleState) {
            cleanup(moduleData);
        }
    });
};
exports.useInstanceCleanup = useInstanceCleanup;
